import React from "react";
import PropTypes from "prop-types";
// Limitless imports
import Grid from "@limitless/modern/layout/Grid";
import Typography from "@limitless/modern/data-display/typography/Typography";
import IconButton from "@limitless/modern/inputs/icon-button/IconButton";
import Divider from "@limitless/modern/data-display/divider/Divider";
import { useExpertRatingContext } from "@limitless/expert";
// Limitless Icons
import SortIcon from "@limitless/icons/Sort";
import SortUpIcon from "@limitless/icons/SortUp";
import SortDownIcon from "@limitless/icons/SortDown";
import Switch from "@limitless/modern/inputs/switch/Switch";
import CommonFilterPoper from "../filters/CommonFilterPoper";

const RatingSort = ({ clickAwayClose }) => {
    const { sortExists, ratingMessageFilters, updateRatingFilters, clearRatingState } = useExpertRatingContext();
    const { dateSort, custRatingSort, qualityRatingSort, dateSortDESC, cusrRatingSortDESC, qualityRatingSortDESC } =
        ratingMessageFilters;

    const ratingSortArray = React.useMemo(() => {
        return [
            {
                name: "webSocketsdateSortSwitch",
                onChange: () =>
                    updateRatingFilters({
                        dateSort: !dateSort,
                        custRatingSort: false,
                        qualityRatingSort: false,
                        dateSortDESC: false
                    }),
                checked: dateSort ? true : false,
                inputProps: { "aria-labelledby": `switch-list-label-${dateSort}` },
                title: "Date",
                icon: dateSortDESC && dateSort ? <SortUpIcon /> : <SortDownIcon />,
                onClick: () => dateSort && updateRatingFilters({ dateSortDESC: !dateSortDESC }),
                id: "dateSortIconButton",
                isSort: dateSortDESC && dateSort,
                isDivider: true
            },
            {
                name: "webSocketscustRatingSortSwitch",
                onChange: () =>
                    updateRatingFilters({
                        custRatingSort: !custRatingSort,
                        dateSort: false,
                        qualityRatingSort: false,
                        cusrRatingSortDESC: false
                    }),
                checked: custRatingSort ? true : false,
                inputProps: { "aria-labelledby": `switch-list-label-${custRatingSort}` },
                title: "Customer Rating",
                icon: cusrRatingSortDESC && custRatingSort ? <SortUpIcon /> : <SortDownIcon />,
                onClick: () => custRatingSort && updateRatingFilters({ cusrRatingSortDESC: !cusrRatingSortDESC }),
                isSort: cusrRatingSortDESC && custRatingSort,
                id: "custRatingSortIconButton",
                isDivider: true
            },
            {
                name: "webSocketsqualityRatingSortSwitch",
                onChange: () =>
                    updateRatingFilters({
                        qualityRatingSort: !qualityRatingSort,
                        custRatingSort: false,
                        dateSort: false,
                        qualityRatingSortDESC: false
                    }),
                checked: qualityRatingSort ? true : false,
                inputProps: { "aria-labelledby": `switch-list-label-${qualityRatingSort}` },
                title: "Quality Rating",
                icon: qualityRatingSortDESC && qualityRatingSort ? <SortUpIcon /> : <SortDownIcon />,
                onClick: () =>
                    qualityRatingSort && updateRatingFilters({ qualityRatingSortDESC: !qualityRatingSortDESC }),
                isSort: qualityRatingSortDESC && qualityRatingSort,
                id: "qualityRatingSortIconButton"
            }
        ];
    }, [ratingMessageFilters]);

    return (
        <>
            <CommonFilterPoper
                label="Sort ratings"
                Icon={<SortIcon />}
                clickAwayClose={clickAwayClose}
                filterExists={sortExists}
                title={"Sort by:"}
                clearFilters={()=>clearRatingState("RESET_MESSAGES_SORT")}
            >
                {ratingSortArray.map(sortOption => {
                    return (
                        <Grid key={sortOption.title} xs={12}>
                            <Grid item pt={2} pb={2} display="flex" flexDirection="row" justifyContent="space-between">
                                <Grid display="flex" flexDirection="row">
                                    <Switch
                                        name={sortOption.name}
                                        onChange={sortOption.onChange}
                                        checked={sortOption.checked}
                                        inputProps={sortOption.inputProps}
                                    />
                                    <Typography variant="body2" color="text.primary">
                                        {sortOption.title}
                                    </Typography>
                                </Grid>
                                <Grid>
                                    <IconButton
                                        label=""
                                        icon={sortOption.icon}
                                        onClick={sortOption.onClick}
                                        sx={{
                                            color: theme =>
                                                sortOption.isSort
                                                    ? theme.palette.primary.main
                                                    : theme.palette.text.disabled
                                        }}
                                        id={sortOption.id}
                                    />
                                </Grid>
                            </Grid>
                            {sortOption.isDivider && <Grid item xs={12} component={Divider} />}
                        </Grid>
                    );
                })}
            </CommonFilterPoper>
        </>
    );
};

RatingSort.propTypes = {
    clickAwayClose: PropTypes.bool
};

export default RatingSort;
